<template>
  <v-row>
    <v-col
      cols="6"
      class="columnCard infoCard"
    >
      <v-container class="matchHeight">
        <v-card
          outlined
          tile
          class="matchHeight infoCard"
        >
          <v-card-title>All Surveys</v-card-title>
          <v-card-text>
            Programs can be toggled between “Multiple Surveys” and “Single Survey” mode. <br> Surveys can be previewed, locked, or added to the list on the right.
          </v-card-text>
        </v-card>
      </v-container>
    </v-col>
    <v-col
      cols="6"
      class="columnCard infoCard"
    >
      <v-container class="matchHeight">
        <v-card
          outlined
          tile
          class="matchHeight infoCard"
        >
          <v-card-title>Selected Surveys</v-card-title>
          <v-card-text>
            Selected surveys will be available for stakeholders to choose from in “Multiple Survey” mode.
          </v-card-text>
        </v-card>
      </v-container>
    </v-col>
    <v-col
      cols="6"
      class="columnCard"
    >
      <AdminSurveys />
    </v-col>
    <v-col
      cols="6"
      class="columnCard"
    >
      <SurveyList />
    </v-col>
  </v-row>
</template>

<script>
import AdminSurveys from "@/components/Admin/AdminSurveys";
import SurveyList from "@/components/Admin/SurveyList";
import { mapActions } from "vuex";

export default {
  components: {
    AdminSurveys,
    SurveyList
  },
  beforeMount() {
    this.getPrograms();
    this.getProjects();
    this.fetchSurveys();
  },
  methods: {
    ...mapActions({
      getPrograms: "programs/getPrograms",
      getProjects: "projects/getProjects",
      fetchSurveys: "survey/fetchSurveys"
    })
  }
};
</script>

<style >
.matchHeight {
  height: 100% !important;
}
.columnCard {
  margin-top: 0%;
  margin-bottom: 0%;
  padding-top: 0%;
  padding-bottom: 0%;
}
.infoCard {
  max-height: 20vh !important;
  overflow-y: auto
}
.infoCard .v-card__title {
  padding-top: 1%;
  padding-bottom: 1%;
}
</style>
